import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCNu80ovTUMqNpuHFtxvDtOpZpbz8xdJis",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "abbott-matcher-60171.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "abbott-matcher-60171",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "abbott-matcher-60171.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1069980477463",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1069980477463:web:dcad957e99dfd7b0135452"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
// Connect to the 'matcher' database (not the default database)
export const db = getFirestore(app, 'matcher');

export default app;
